module.exports = __webpack_public_path__ + "static/media/auth-sprites.73ceb17c.svg";